module.exports = __webpack_public_path__ + "img/sintesis.7b04f085.svg";